<template>
  <div id="about">
    <!--banner-->
    <div class="swiper-container swiper-no-swiping common" id="banner">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide swiper-slide-banner"
          style="background-image: url('https://img.deepbaytech.com/fn/abouttop.png')"
        >
          <div class="swiper-slide-title">
            <div style="font-size: 48px; padding-left: 20px; margin: 0 auto;">
              关于深湾
            </div>
            <div
              style="font-size: 20px; padding-left: 20px; margin: 12px auto 18px auto"
            >
              加速创新，为AI行业赋能，引领智慧发展
            </div>
            <a @click="hClick" class="service">服务咨询</a>
          </div>
        </div>
      </div>
    </div>
    <!--弹框-->
    <el-dialog
      :lock-scroll="false"
      v-if="dialogVisible"
      title="服务咨询"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="hClose"
    >
      <el-form
        class="dialog"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="labelPosition"
      >
        <el-form-item label="联系人：" prop="username">
          <el-input
            v-model.trim="ruleForm.username"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input
            v-model.number="ruleForm.phone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input
            v-model.trim="ruleForm.email"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司名称：" prop="companyName">
          <el-input
            v-model.trim="ruleForm.companyName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地：" prop="companyAddr">
          <el-input
            v-model.trim="ruleForm.companyAddr"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题描述：" prop="question">
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model.trim="ruleForm.question"
            resize="none"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="success" @click="submitForm" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <div class="container">
      <div class="fff-ds">
        <div class="fff-container">
          <div class="text">
            <el-row class="text-bottom">
              <el-col class="left">
                <p class="ai-deep">公司介绍</p>
                <p class="nvidia">
                  北京深湾科技有限公司（DeepBay
                  Technologies）是人工智能高科技企业，在机器学习、深度学习、高性能计算、视觉计算、语义分析、大数据处理等重要领域已建立了优秀的技术团队和人工智能产品平台体系。深湾科技致力于研发人工智能产业支撑平台，协助政府和企业客户创建一流水平的AI基础设施，引进国际先进的AI创新技术、创新产品和创新模式，建立人工智能与实体经济融合发展新范式。
                </p>
              </el-col>
              <el-col>
                <div class="img-right-box">
                  <img
                    class="img-right"
                    src="https://img.deepbaytech.com/images2021/introduction.png"
                  />
                </div>
              </el-col>
            </el-row>
            <el-row class="text-top">
              <el-col>
                <img
                  class="img-left"
                  src="https://img.deepbaytech.com/images2021/technology.png"
                />
              </el-col>
              <el-col class="right">
                <p class="ai-deep">核心技术</p>
                <p class="nvidia">
                  深湾科技在长期产品研发和项目实施中积累了对NVIDIA
                  GPU、CUDA、Rapids、Isaac、Clara、DeepStream、Metropolis、Omniverse、Mellanox
                  IB高速网络等关键技术的丰富经验，具有基于NVIDIA
                  SuperPOD架构进行“计算+网络+存储”AI数据中心的实施交付专业服务能力。深湾科技具有优秀的人工智能云计算服务平台能力，设计研发了人工智能技术赋能公共服务平台，为企业及科研机构提供构建、训练、部署、优化神经网络模型和算法的人工智能资源调度管理平台及模型训练平台，协助研发人员利用国际先进的AI资源进行AI产品及算法创新，大幅缩短底层技术学习周期、降低使用门槛，协助企业研发人员专注于自身核心业务的技术创新。同时，深湾科技具有优秀的计算机视觉能力，在图像分类、目标主体检测、图像特征、亿级大规模图像检索等领域形成了自有算法模型体系，正在研发智能机器人、智能制造、工业视觉设计等创新赋能平台。
                </p>
              </el-col>
            </el-row>
          </div>
        </div>
        <!--合作授权-->
        <div class="cooperation">
          <div class="cooperation-title">合作授权</div>
          <div class="cooperation-text">
            深湾科技获得美国NVIDIA公司实施交付专业服务合作伙伴（Service Delivery
          Partner-Professional
          Service）、数据中心产品增值销售、IB网络产品增值销售、AI
          Enterprise软件增值销售、DGX Cloud云服务等多项授权，获得美国DDN（Data
          Direct
          Networks）公司高速存储产品中国区增值销售合作伙伴授权，获得美国NetApp公司高速存储产品中国区增值销售合作伙伴授权，具备智算中心计算、网络、存储、软件等领域解决方案设计实施综合技术服务能力。
          </div>
          <div class="cooperation-box">
            <div class="cooperation-img">
              <img
                width="165px"
                height="32px"
                src="https://img.deepbaytech.com/%E4%BD%8D%E5%9B%BE%402x1.png"
                alt=""
              />
            </div>
            <!-- <div class="cooperation-img">
              <img
                width="157px"
                height="32px"
                src="https://img.deepbaytech.com/111697020180_.pic%402x.png"
                alt=""
              />
            </div> -->
            <div class="cooperation-img">
              <img
                width="109px"
                height="38px"
                src="https://img.deepbaytech.com/%E4%BD%8D%E5%9B%BE%402x2.png"
                alt=""
              />
            </div>
            <div class="cooperation-img">
              <img
                width="173px"
                height="32px"
                src="https://img.deepbaytech.com/netAPP%20%282%29.png"
                alt=""
              />
            </div>
          </div>
          <!-- <el-row class="text-bottom">
            <el-col class="left">
              <p class="ai-deep">合作授权</p>
              <p class="nvidia">
                深湾科技获得美国NVIDIA公司授权的中国区专业实施交付服务合作伙伴（Service
                Delivery Partner-Professional Service）,获得NVIDIA
                DGX超级计算机中国区增值代理合作伙伴授权，获得NVIDIA
                解决方案合作伙伴（Solution Provider）授权，获得NVIDIA Mellanox
                高速网络产品中国区增值代理合作伙伴授权，获得美国DDN（Data Direct
                Networks）高速存储产品中国区增值代理合作伙伴授权。
              </p>
            </el-col>
            <el-col>
              <div class="img-right-box">
                <img
                  class="authorization"
                  src="../../../public/images/authorization1.png"
                />
                <img class="ddn" src="../../../public/images/ddn1.png" />
              </div>
            </el-col>
          </el-row> -->
        </div>
        <!--加入我们-->
        <div class="recruit">
          <p>加入我们</p>
          <div class="recruit-table">
            <div>
              <span>热招职位</span>
            </div>
            <div v-if="tableData.length > 5">
              <!--              <el-input class="autocomplete-bottom" popper-class="my-autocomplete" v-model="search"-->
              <!--                placeholder="搜索职位">-->
              <!--                <i class="icon-search" slot="suffix" @click="handleSearch">-->
              <!--                  <img src="https://img.deepbaytech.com/images2021/icon_search.png">-->
              <!--                </i>-->
              <!--              </el-input>-->
            </div>
          </div>
          <div class="table">
            <div class="line"></div>
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{
                background: '#FAFAFA',
                color: '#333333',
              }"
            >
              <el-table-column prop="name" label="职位名称" width="295">
              </el-table-column>
              <el-table-column prop="category" label="职位类别" width="295">
                研发类
              </el-table-column>
              <el-table-column prop="workplace" label="工作地点" width="295">
                北京
              </el-table-column>
              <!--              <el-table-column prop="money" label="薪资" width="236">-->
              <!--              </el-table-column>-->
              <el-table-column prop="time" label="发布时间" width="295"
                >2024-03-01
              </el-table-column>
            </el-table>
          </div>
          <!--          <div class="pagination" v-if="tableData.length>5">-->
          <!--            <el-pagination style="text-align:right" background layout="prev, pager, next"-->
          <!--              :total="tableData.length" :page-size="pageParams.pageSize"-->
          <!--              :current-page.sync="curPage" @current-change="hCurrentChange">-->
          <!--            </el-pagination>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <!--服务咨询-->
    <Consultation class="common" />
    <!-- 尾部 -->
    <Footer class="common" />
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";
import Consultation from "./../../components/Consultation/Consultation";
import Footer from "./../../components/Footer/Footer";
import { getServiceConsultation } from "@/api";
export default {
  name: "About",
  components: {
    Consultation,
    Footer,
  },
  data() {
    return {
      dialogVisible: false,
      textarea: "",
      search: "",
      labelPosition: "left",
      ruleForm: {
        username: "",
        phone: "",
        email: "",
        companyName: "",
        companyAddr: "",
        question: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入联系人名称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        companyAddr: [
          { required: true, message: "请输入所在地", trigger: "blur" },
        ],
        question: [
          { required: true, message: "请输入问题描述", trigger: "blur" },
        ],
      },
      pageParams: {
        pageSize: 5,
        page: 1,
      },
      curPage: 1,
      tableData: [
        {
          name: "k8s高级研发工程师",
          money: "10k-15k",
        },
        {
          name: "java开发工程师",
          money: "10k-15k",
        },
        {
          name: "解决方案产品经理",
          money: "10k-15k",
        },
        {
          name: "python开发工程师",
          money: "10k-15k",
        },
        {
          name: "java架构师",
          money: "10k-15k",
        },
        {
          name: "硬件工程师",
          money: "10k-15k",
        },
      ],
    };
  },
  mounted() {
    new Swiper("#banner", {
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
  methods: {
    aiCloudHandle: function(mode, event) {
      var parentNode = event.target.parentNode;
      if (mode) {
        parentNode.classList.add("hoveractive");
      } else {
        parentNode.classList.remove("hoveractive");
      }
    },
    handleSearch() {
      this.$router.push("/join/details");
    },
    handleClose() {
      this.dialogVisible = false;
      this.ruleForm = {};
    },
    hClose() {
      this.ruleForm = {};
    },
    hClick() {
      this.dialogVisible = true;
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          getServiceConsultation(this.ruleForm).then(() => {
            alert("发送成功");
            this.dialogVisible = false;
            console.log(this.ruleForm);
          });
        } else {
          alert("请输入必填项");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.common {
  min-width: 1180px;
}
.hoveractive {
  transform: translateY(-20px);
}
.swiper-container {
  height: 480px;
}
.swiper-slide-banner {
  width: 100%;
  height: 480px !important;
}
.swiper-slide {
  position: relative;
  background-size: cover;
}
.swiper-slide-title {
  color: #fff;
  width: 1180px;
  margin: 0 auto;
  padding-top: 170px;
}
.service {
  font-size: 16px;
  margin: 12px auto 18px 20px;
  text-decoration: none;
  display: inline-block;
  width: 140px;
  height: 40px;
  background: #77ba00;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
}
.container {
  width: 100%;
  min-width: 1180px;
  background-color: #fff;
}
.fff-ds {
  color: #333;
}
.fff-container {
  width: 1180px;
  margin: auto;
}
.fff-container-a {
  width: 100%;
}
.fff-t {
  color: #333333;
  font-size: 40px;
  text-align: center;
  padding-top: 80px;
}
.fff-p-about {
  padding-top: 20px;
  color: #333333;
  font-size: 20px;
}
.fff-c-about {
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.fff-itm {
  width: 570px;
  height: 500px;
  max-width: 570px;
  background: #fff;
  overflow: hidden;
  /* border-radius: 4px; */
  transition: 0.5s;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
}
.fff-itm.active {
  transform: translateY(-20px);
}
.fff-itm-imgs {
  width: 570px;
  height: 320px;
  overflow: hidden;
}
.fff-itm-img {
  width: 100%;
  height: 100%;
  transition: 0.5s;
}
.fff-itm-img:hover {
  transform: scale(1.2, 1.2);
}
.fff-itm-b:hover .fff-itm {
  color: red;
}
.fff-itb-t {
  margin: 24px 0 16px 24px;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
}
.fff-itb-c {
  line-height: 22px;
  color: #666666;
  font-size: 16px;
  margin: 0 24px 0 24px;
}
.fff-b-b {
  width: 100%;
  text-align: center;
}
.about-deepbay {
  width: 100%;
  height: 445px;
  margin-top: 40px;
  background: url("https://img.deepbaytech.com/fn/about.jpg");
  background-size: 100% 100%;
  color: #ffffff;
  position: relative;
}
.about-deepbay-text {
  width: 476px;
  position: absolute;
  right: 15%;
  top: 80px;
}
.about-deepbay-text-title {
  font-size: 32px;
}
.about-deepbay-text-p {
  font-size: 16px;
  margin-top: 40px;
  line-height: 26px;
}
.text-top {
  display: flex;
  height: 320px;
  width: 100%;
  max-width: 1180px;
  margin: 80px auto 0;
  align-items: center;
}
.img-left {
  width: 580px;
  height: 320px;
}
.right {
  width: 560px;
  margin-left: 40px;
}
.ai-deep {
  color: #333;
  font-size: 24px;
  line-height: 33px;
  font-weight: 400;
}
.nvidia {
  width: 560px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  margin-top: 20px;
}
.text-bottom {
  display: flex;
  height: 320px;
  width: 100%;
  max-width: 1180px;
  margin: 80px auto 60px;
  align-items: center;
}
.left {
  width: 560px;
}
.img-right-box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.img-right {
  width: 580px;
  height: 320px;
  margin-left: 40px;
}
.cooperation {
  width: 100%;
  background: #f6f8fb;
  padding-bottom: 40px;
}
.cooperation-title {
  color: #333333;
  font-size: 28px;
  text-align: center;
  padding-top: 80px;
  margin-top: 80px;
}
.cooperation-text {
  width: 1180px;
  color: #333333;
  font-size: 16px;
  text-align: center;
  margin: 20px auto 40px;
}
.cooperation-box {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cooperation-img {
  width: 320px;
  height: 80px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.authorization {
  width: 248px;
  height: 48px;
  margin-right: 48px;
  margin-left: 63px;
}
.ddn {
  width: 138px;
  height: 48px;
}
.recruit {
  width: 1180px;
  margin: 80px auto auto auto;
  padding-bottom: 80px;
}
.recruit p {
  color: #333333;
  font-size: 40px;
  text-align: center;
  margin-top: 60px;
  margin-bottom: 40px;
}
.recruit-table {
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  color: #333333;
  font-size: 18px;
}
.look:hover {
  color: #77ba00 !important;
}
.category-item {
  width: 64px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  color: #666666;
  font-size: 16px;
  margin-right: 40px;
}
.category-item-active {
  width: 64px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  color: #ffffff;
  font-size: 16px;
  background: #77ba00;
  margin-right: 40px;
}
.autocomplete-bottom ::v-deep .el-input__inner {
  width: 320px;
  height: 32px;
  border: 1px solid #999999;
  border-radius: 0%;
  padding-left: 14px;
  color: #333;
  font-size: 14px;
}
::v-deep input::-webkit-input-placeholder {
  color: #999999;
}
.autocomplete-bottom {
  position: relative;
}
.autocomplete-bottom .icon-search {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -48%);
  display: inline-block;
}
.autocomplete-bottom .icon-search img {
  width: 32px;
  height: 32px;
}
.table /deep/tbody tr:hover > td {
  cursor: pointer;
  background-color: #fafafa;
}
.line {
  width: 1180px;
  height: 1px;
  background: #eaeaea;
}
.pagination {
  margin-top: 24px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #77ba00;
  border: none;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #606266;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-pagination button {
  background-color: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.dialog {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  margin-top: 15px;
  padding: 24px 24px 0 24px;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .el-textarea__inner {
  height: 144px;
  border-radius: 0;
  padding-left: 12px;
}
::v-deep .el-textarea__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
::v-deep .el-input__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
::v-deep .el-dialog__footer {
  padding: 15px 24px 15px 0;
}
.el-button {
  border-radius: 0;
}
.el-button--success {
  color: #fff;
  background-color: #77ba00;
  border-color: #77ba00;
}
::v-deep .el-input__inner {
  width: 240px;
  height: 32px;
  border-radius: 0%;
}
::v-deep .el-dialog__close:hover {
  color: #77ba00 !important;
}
.el-button--success:hover {
  background-color: #77ba00;
}
.el-button--default:hover {
  background-color: #fff;
  color: #666666;
  border: 1px solid #dddddd;
}
#about ::v-deep .el-dialog {
  min-width: 570px;
  margin: 0 auto 0px;
}
</style>
